export default __webpack_public_path__ + "assets/fonts/toolbar-icon.a2420e23cc129ded78821a18c7cc2448.woff2";